import { gettext } from "../utils/legacy";
import React from "react";

const CancelButton = ({ children, ...props }: React.ButtonHTMLAttributes<HTMLButtonElement>) => (
  <button type="button" className="btn btn-light" {...props}>
    {children || gettext("Cancel")}
  </button>
);
export default CancelButton;
